<div class="predictions-container">
  <!-- The list of results -->
  <div class="predictions-list">
    @if (isLoading()) {
    <div class="prediction-item">Loading...</div>
    } @else { @for (prediction of predictions(); track prediction.placeId) {
    <div class="prediction-item" (mousedown)="onSelect(prediction)">
      <div class="prediction-main-text">
        {{ prediction.mainText }}
      </div>
      <div class="prediction-secondary-text">
        {{ prediction.secondaryText }}
      </div>
    </div>
    } @if (predictions().length === 0 && !isLoading()) {
    <div class="prediction-item no-results">No results found.</div>
    } }
  </div>
</div>
